// react components
import React from 'react'
import {
    Link,
} from 'react-router-dom'

// props
type IconBlock825Props = {
    active?: boolean
    className?: string
    color2?: string
    color?: 'light'
    disabled?: boolean
    edit: boolean
    href?: string
    iconClass: string
    onClick?: (e: any) => void
    to?: string
    tooltipText?: string
}

// main
export const IconBlock825: React.FC<IconBlock825Props> = React.memo(({
    active,
    className,
    color,
    color2,
    disabled,
    edit,
    href,
    iconClass,
    onClick,
    to,
    tooltipText,
}) => {

    if (href) {
        return (
            <a
                className={`main-icon-block-825${color ? ` ${color}` : ''}${className ? ` ${className}` : ''}`}
                // disabled={edit || disabled}  TODO
                href={href}
                rel='noopener noreferrer'
                onClick={edit ? undefined : onClick}
                title={tooltipText}
                target='_blank'
            >
                <i
                    className={`main-icon ${iconClass}${active ? ' color' : ''}`}
                    style={{
                        color: color2,
                    }}
                />
            </a>
        )
    }

    if (to) {
        return (
            <Link
                className={`main-icon-block-825${color ? ` ${color}` : ''}${className ? ` ${className}` : ''}`}
                // disabled={edit || disabled}  TODO
                onClick={edit ? undefined : onClick}
                title={tooltipText}
                to={to}
            >
                <i
                    className={`main-icon ${iconClass}${active ? ' color' : ''}`}
                    style={{
                        color: color2,
                    }}
                />
            </Link>
        )
    }

    return (
        <button
            className={`main-icon-block-825${color ? ` ${color}` : ''}${className ? ` ${className}` : ''}`}
            disabled={edit || disabled}
            onClick={edit ? undefined : onClick}
            title={tooltipText}
        >
            <i
                className={`main-icon ${iconClass}${active ? ' color' : ''}`}
                style={{
                    color: color2,
                }}
            />
        </button>
    )
})
